export default from './Seo';



// WEBPACK FOOTER //
// ./src/sharedComponents/Seo/index.js